import _ from 'lodash';
import React from 'react';

const Discount = ({ fabrication, stencil }) => {
  if (!fabrication || !fabrication.selected) return null;
  if (!stencil || !stencil.selected) return null;

  const discount = parseFloat(stencil.subTotal) * 0.2;

  return (
    <div className="cart-section">
      <div className="title">Stencil Discount</div>
      <div className="price discount">${_.round(discount, 2)}</div>
    </div>
  );
};

export default Discount;
